import { createSlideIcon, type IconProps } from '../SlideTypeIcon';

const DEFAULT_COLOR = 'var(--palette-coral-300)';

const Icon24x24 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <>
    <path
      d="M14 9C14 11.7614 11.7614 14 9 14H4V9C4 6.23858 6.23858 4 9 4C11.7614 4 14 6.23858 14 9Z"
      fill={textColor}
    />
    <path
      d="M13 16.5C13 18.433 14.567 20 16.5 20H20V16.5C20 14.567 18.433 13 16.5 13C14.567 13 13 14.567 13 16.5Z"
      fill={textColor}
    />
    <path
      d="M14 9C14 11.7614 11.7614 14 9 14H4V9C4 6.23858 6.23858 4 9 4C11.7614 4 14 6.23858 14 9Z"
      fill={textColor}
    />
    <path
      d="M13 16.5C13 18.433 14.567 20 16.5 20H20V16.5C20 14.567 18.433 13 16.5 13C14.567 13 13 14.567 13 16.5Z"
      fill={textColor}
    />
  </>
);

const Icon32x32 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <>
    <path
      d="M16.3201 20.7999C16.3201 23.3625 18.3975 25.4399 20.9601 25.4399H25.6001V20.7999C25.6001 18.2373 23.5227 16.1599 20.9601 16.1599C18.3975 16.1599 16.3201 18.2373 16.3201 20.7999Z"
      fill={textColor}
    />
    <path
      d="M17.9199 12.1599C17.9199 15.3411 15.3411 17.9199 12.1599 17.9199H6.39992V12.1599C6.39992 8.97876 8.97876 6.39992 12.1599 6.39992C15.3411 6.39992 17.9199 8.97876 17.9199 12.1599Z"
      fill={textColor}
    />
  </>
);

export const QfaIcon = createSlideIcon(Icon24x24, Icon32x32);
